import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "position-fixed d-block d-md-none",
  style: {"z-index":"999","right":"20px","top":"90px"}
}
const _hoisted_2 = {
  class: "nav-link dropdown-toggle hide-arrow",
  href: "#addtocard"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "currentColor",
  class: "bi bi-cart4",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5M3.14 5l.5 2H5V5zM6 5v2h2V5zm3 0v2h2V5zm3 0v2h1.36l.5-2zm1.11 3H12v2h.61zM11 8H9v2h2zM8 8H6v2h2zM5 8H3.89l.5 2H5zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0" })
], -1)
const _hoisted_4 = { class: "badge bg-danger rounded-pill badge-notifications" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "card mb-1" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-9" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = {
  type: "button",
  class: "btn btn-primary me-2 mt-sm-0 mt-2"
}
const _hoisted_14 = {
  type: "button",
  class: "btn btn-default border mt-sm-0 mt-2"
}
const _hoisted_15 = { class: "card" }
const _hoisted_16 = { class: "card-body table-responsive" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "d-md-block d-none" }
const _hoisted_22 = {
  key: 0,
  class: "table card-table"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Price"),
    /*#__PURE__*/_createElementVNode("th", null, "In Stock"),
    /*#__PURE__*/_createElementVNode("th", null, "#")
  ])
], -1)
const _hoisted_24 = { class: "table-border-bottom-0" }
const _hoisted_25 = { class: "mb-0" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 0,
  class: "text-danger text-capitalize"
}
const _hoisted_29 = {
  key: 1,
  class: "text-danger text-capitalize"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h5", { class: "m-0 text-center" }, " No Item Found", -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { class: "d-md-none d-block" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "mb-0 fw-thin" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "Sell ", -1)
const _hoisted_39 = /*#__PURE__*/_createTextVNode("/ Buy ")
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "Price:", -1)
const _hoisted_41 = /*#__PURE__*/_createTextVNode()
const _hoisted_42 = { class: "" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  class: "text-danger text-capitalize"
}
const _hoisted_46 = ["onClick"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = {
  class: "card mb-1 mt-sm-0 mt-3",
  id: "addtocard"
}
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = {
  class: "nav nav-pills nav-fill flex-nowrap",
  id: "pillNav2",
  role: "tablist"
}
const _hoisted_52 = {
  class: "nav-link active rounded-5",
  id: "walk-tab",
  "data-bs-toggle": "pill",
  "data-bs-target": "#walk-in-customer",
  type: "button",
  role: "tab",
  "aria-selected": "true"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label w-100",
  for: "walk_in_customer"
}, " Walk-In ", -1)
const _hoisted_54 = {
  class: "nav-link rounded-5",
  id: "registered-tab",
  "data-bs-toggle": "pill",
  "data-bs-target": "#registered-tab-pane",
  type: "button",
  role: "tab",
  "aria-selected": "false"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label w-100",
  for: "registered_customer"
}, " Registered ", -1)
const _hoisted_56 = {
  class: "tab-content py-4 px-0",
  id: "myTabContent"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade show active",
  id: "walk-in-customer",
  role: "tabpanel",
  "aria-labelledby": "walk-tab"
}, null, -1)
const _hoisted_58 = {
  class: "tab-pane fade",
  id: "registered-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "registered-tab"
}
const _hoisted_59 = { key: 0 }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "text-danger text-wrap" }, " Please Enter the Registered Customer To Manage the Due Amount", -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = { class: "d-flex flex-sm-nowrap flex-wrap justify-content-between" }
const _hoisted_63 = { class: "mb-3 me-3 w-100" }
const _hoisted_64 = ["required"]
const _hoisted_65 = {
  key: 0,
  class: "form-control suggestions-list"
}
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { class: "mb-3 me-3 w-100" }
const _hoisted_68 = { class: "d-flex flex-sm-nowrap flex-wrap justify-content-between" }
const _hoisted_69 = { class: "mb-3 me-3 w-100" }
const _hoisted_70 = { class: "card" }
const _hoisted_71 = { class: "" }
const _hoisted_72 = { class: "d-md-flex d-none" }
const _hoisted_73 = { class: "card-body table-responsive" }
const _hoisted_74 = {
  key: 0,
  class: "table card-table"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl."),
    /*#__PURE__*/_createElementVNode("th", null, "Product"),
    /*#__PURE__*/_createElementVNode("th", null, "Price x Qty"),
    /*#__PURE__*/_createElementVNode("th", null, "Total"),
    /*#__PURE__*/_createElementVNode("th", null, "-")
  ])
], -1)
const _hoisted_76 = { class: "table-border-bottom-0" }
const _hoisted_77 = { class: "input-group" }
const _hoisted_78 = { class: "form-control-sm mx-0" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "form-control-sm mx-0" }, "X", -1)
const _hoisted_80 = ["onUpdate:modelValue", "onInput"]
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  key: 1,
  class: "text-center fw-bold"
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("h6", { class: "m-0" }, "Please Add Some Product", -1)
const _hoisted_84 = [
  _hoisted_83
]
const _hoisted_85 = { class: "mobile-view d-block d-md-none" }
const _hoisted_86 = {
  key: 0,
  class: "card-body"
}
const _hoisted_87 = { class: "" }
const _hoisted_88 = { class: "input-group" }
const _hoisted_89 = { class: "" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_91 = /*#__PURE__*/_createElementVNode("strong", null, " X ", -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "" }, " Quantity:", -1)
const _hoisted_94 = ["onUpdate:modelValue", "onInput"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_97 = {
  key: 1,
  class: "card-body"
}
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bold m-0 p-0" }, "Please Add Some Product", -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "card mt-1" }
const _hoisted_101 = { class: "card-body table-responsive my-0 d-md-flex d-none" }
const _hoisted_102 = { class: "table card-table" }
const _hoisted_103 = { class: "table-border-bottom-0 text-end" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("th", { class: "col-8" }, "Total", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("th", null, "Discount (%)", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("th", null, "Sub Total", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("th", null, "Payment", -1)
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = { class: "input-group input-group-sm w-100" }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "Please Enter Valid Amount", -1)
const _hoisted_112 = [
  _hoisted_111
]
const _hoisted_113 = { class: "card-body table-responsive my-0 d-md-none d-block" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Total: ")
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Discount (%) ")
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Sub Total: ")
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Payment: ")
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Due: ")
const _hoisted_119 = { key: 0 }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("small", { class: "text-danger" }, "Please Enter Valid Amount", -1)
const _hoisted_121 = [
  _hoisted_120
]
const _hoisted_122 = { class: "card mt-1" }
const _hoisted_123 = { class: "card-body" }
const _hoisted_124 = { class: "row" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4 col-sm-12" }, null, -1)
const _hoisted_126 = { class: "col-md-8 col-sm-12 text-end" }
const _hoisted_127 = {
  href: "",
  class: "btn btn-default border m-1"
}
const _hoisted_128 = ["disabled"]
const _hoisted_129 = { key: 0 }
const _hoisted_130 = {
  key: 1,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_131 = {
  key: 2,
  class: "visually-show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.totalQuantity > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.totalQuantity), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Enter Search Key!",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchKey) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.searchKey]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", _hoisted_13, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'magnifying-glass'],
                    onClick: _ctx.searchProductData
                  }, null, 8, ["onClick"])
                ]),
                _createElementVNode("button", _hoisted_14, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fas', 'xmark'],
                    onClick: _ctx.clearSearchKey
                  }, null, 8, ["onClick"])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.fettchDataArray.length > 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("tbody", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: dataItem.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("p", _hoisted_25, _toDisplayString(dataItem.name), 1),
                                  _createElementVNode("small", null, _toDisplayString(dataItem.category?.name), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("strong", null, _toDisplayString(dataItem.sell_price), 1),
                                  _createTextVNode("/ " + _toDisplayString(dataItem.buy_price), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  (dataItem.stocks[0]?.total_quantity)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(dataItem.stocks[0]?.total_quantity), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_27, "00 "))
                                ]),
                                _createElementVNode("td", null, [
                                  (dataItem.stocks[0]?.total_quantity == null)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Add Stock"))
                                    : (parseInt(dataItem.stocks[0]?.total_quantity) <= 0)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, " Stock Out "))
                                      : (_openBlock(), _createElementBlock("button", {
                                          key: 2,
                                          type: "button",
                                          class: "me-2 btn btn-sm btn-primary",
                                          onClick: ($event: any) => (_ctx.addItemToCart(dataItem))
                                        }, [
                                          _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] })
                                        ], 8, _hoisted_30))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mb-4",
                        key: dataItem.id
                      }, [
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("strong", _hoisted_36, "Name: " + _toDisplayString(dataItem.name), 1),
                          _createElementVNode("small", null, " (" + _toDisplayString(dataItem.category?.name) + ") ", 1),
                          _createElementVNode("p", _hoisted_37, [
                            _hoisted_38,
                            _hoisted_39,
                            _hoisted_40,
                            _hoisted_41,
                            _createElementVNode("strong", null, _toDisplayString(dataItem.sell_price), 1),
                            _createTextVNode(" / " + _toDisplayString(dataItem.buy_price), 1)
                          ]),
                          _createElementVNode("p", _hoisted_42, [
                            (dataItem.stocks[0]?.total_quantity)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Qantity: " + _toDisplayString(dataItem.stocks[0]?.total_quantity), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_44, "00"))
                          ]),
                          (parseInt(dataItem.stocks[0]?.total_quantity) <= 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, "Out of Stock"))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "me-2 btn btn-sm btn-primary",
                                onClick: ($event: any) => (_ctx.addItemToCart(dataItem))
                              }, [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] })
                              ], 8, _hoisted_46))
                        ]),
                        _hoisted_47
                      ]))
                    }), 128))
                  ])
                ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("form", {
          onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addOrderFunc && _ctx.addOrderFunc(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("button", _hoisted_52, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input d-none",
                      type: "radio",
                      name: "customer_type",
                      id: "walk_in_customer",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saleForm.customer_type) = $event)),
                      value: "Walk In Customer",
                      checked: ""
                    }, null, 512), [
                      [_vModelRadio, _ctx.saleForm.customer_type]
                    ]),
                    _hoisted_53
                  ]),
                  _createElementVNode("button", _hoisted_54, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input d-none",
                      type: "radio",
                      name: "customer_type",
                      id: "registered_customer",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saleForm.customer_type) = $event)),
                      value: "Registered Customer"
                    }, null, 512), [
                      [_vModelRadio, _ctx.saleForm.customer_type]
                    ]),
                    _hoisted_55
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("div", _hoisted_58, [
                    (_ctx.registrationMessage)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, _hoisted_61))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "Customer Phone",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saleForm.customer.phone) = $event)),
                          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchCustomer && _ctx.searchCustomer(...args))),
                          required: _ctx.saleForm.customer_type == 'Registered Customer'
                        }, null, 40, _hoisted_64), [
                          [_vModelText, _ctx.saleForm.customer.phone]
                        ]),
                        (_ctx.suggestions.length)
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_65, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (customer) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: customer.id,
                                  onClick: ($event: any) => (_ctx.selectCustomer(customer)),
                                  class: "p-2"
                                }, _toDisplayString(customer.phone), 9, _hoisted_66))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          id: "name",
                          placeholder: "Customer Name",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saleForm.customer.name) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.saleForm.customer.name]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("div", _hoisted_69, [
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          class: "form-control",
                          id: "name",
                          placeholder: "Customer Address",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.saleForm.customer.address) = $event)),
                          rows: "3"
                        }, null, 512), [
                          [_vModelText, _ctx.saleForm.customer.address]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  (_ctx.cartItems.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_74, [
                        _hoisted_75,
                        _createElementVNode("tbody", _hoisted_76, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                              _createElementVNode("td", null, _toDisplayString(item.product), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_77, [
                                  _createElementVNode("span", _hoisted_78, _toDisplayString(item.price), 1),
                                  _hoisted_79,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "number",
                                    class: "form-control form-control-sm w-50",
                                    min: "1",
                                    "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                    onInput: ($event: any) => (_ctx.calculateItemPriceByQuantity(index))
                                  }, null, 40, _hoisted_80), [
                                    [_vModelText, item.quantity]
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(parseFloat(item.total.toString()).toFixed(2)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-sm btn-danger",
                                  onClick: ($event: any) => (_ctx.removeFromCart(index))
                                }, " X ", 8, _hoisted_81)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_82, _hoisted_84))
                ])
              ]),
              _createElementVNode("div", _hoisted_85, [
                (_ctx.cartItems.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartItems, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("strong", null, "Name: " + _toDisplayString(item.product), 1),
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("span", _hoisted_89, "Price: " + _toDisplayString(item.price) + " Buy Price: " + _toDisplayString(item.buy_price), 1),
                              _hoisted_90,
                              _hoisted_91,
                              _hoisted_92,
                              _hoisted_93,
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control form-control-sm ms-2",
                                min: "1",
                                "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                onInput: ($event: any) => (_ctx.calculateItemPriceByQuantity(index))
                              }, null, 40, _hoisted_94), [
                                [_vModelText, item.quantity]
                              ])
                            ]),
                            _createElementVNode("p", null, "Total: " + _toDisplayString(parseFloat(item.total.toString()).toFixed(2)), 1),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-danger",
                              onClick: ($event: any) => (_ctx.removeFromCart(index))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'circle-xmark'] })
                            ], 8, _hoisted_95)
                          ]),
                          _hoisted_96
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_97, _hoisted_99))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_100, [
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("table", _hoisted_102, [
                _createElementVNode("tbody", _hoisted_103, [
                  _createElementVNode("tr", null, [
                    _hoisted_104,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.saleForm.total) = $event)),
                        min: "0",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _ctx.saleForm.total]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_105,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.saleForm.discount) = $event)),
                        min: "0",
                        onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.calculateSubTotal()))
                      }, null, 544), [
                        [_vModelText, _ctx.saleForm.discount]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_106,
                    _createElementVNode("td", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.saleForm.sub_total) = $event)),
                        min: "0",
                        readonly: ""
                      }, null, 512), [
                        [_vModelText, _ctx.saleForm.sub_total]
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_107,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("div", _hoisted_109, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm w-50",
                            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.calculateChangeAmount())),
                            placeholder: "Enter Payment",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.saleForm.payment) = $event)),
                            min: "0"
                          }, null, 544), [
                            [_vModelText, _ctx.saleForm.payment]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.change_amount) = $event)),
                            readonly: ""
                          }, null, 512), [
                            [_vModelText, _ctx.change_amount]
                          ])
                        ]),
                        (_ctx.inputValidity)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, _hoisted_112))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              _createElementVNode("p", null, [
                _hoisted_114,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.saleForm.total) = $event)),
                  min: "0",
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.saleForm.total]
                ])
              ]),
              _createElementVNode("p", null, [
                _hoisted_115,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.saleForm.discount) = $event)),
                  min: "0",
                  onInput: _cache[16] || (_cache[16] = ($event: any) => (_ctx.calculateSubTotal()))
                }, null, 544), [
                  [_vModelText, _ctx.saleForm.discount]
                ])
              ]),
              _createElementVNode("p", null, [
                _hoisted_116,
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.saleForm.sub_total) = $event)),
                  min: "0",
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.saleForm.sub_total]
                ])
              ]),
              _createElementVNode("p", null, [
                _hoisted_117,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.calculateChangeAmount())),
                  placeholder: "Enter Payment",
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.saleForm.payment) = $event)),
                  min: "0"
                }, null, 544), [
                  [_vModelText, _ctx.saleForm.payment]
                ])
              ]),
              _createElementVNode("p", null, [
                _hoisted_118,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control form-control-sm",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.change_amount) = $event)),
                  readonly: ""
                }, null, 512), [
                  [_vModelText, _ctx.change_amount]
                ])
              ]),
              (_ctx.inputValidity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_119, _hoisted_121))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_122, [
            _createElementVNode("div", _hoisted_123, [
              _createElementVNode("div", _hoisted_124, [
                _hoisted_125,
                _createElementVNode("div", _hoisted_126, [
                  _createElementVNode("a", _hoisted_127, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'broom'] })
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary m-1",
                    disabled: _ctx.submitBtn || _ctx.cartItems.length <= 0
                  }, [
                    (!_ctx.submitBtn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_129, "Confirm"))
                      : _createCommentVNode("", true),
                    (_ctx.submitBtn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_130))
                      : _createCommentVNode("", true),
                    (_ctx.submitBtn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_131, " Selling..."))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_128)
                ])
              ])
            ])
          ])
        ], 32)
      ])
    ])
  ], 64))
}